import { ensureThemeJsonArray, getDvSourceImageUrl } from "../../functions/themeAssets";

export const IMAGE_QUIZ_CHOICE_SLOTS = [
  { key: "option_one", cardBg: "#e8f8ee", accent: "#3dbb6d" },
  { key: "option_two", cardBg: "#fff8e6", accent: "#f0b429" },
  { key: "option_three", cardBg: "#fdeef2", accent: "#e87b8c" },
  { key: "option_four", cardBg: "#eef3ff", accent: "#5b8def" },
];

export function getImageQuizChoiceSlots(question) {
  return IMAGE_QUIZ_CHOICE_SLOTS.map((slot) => ({
    ...slot,
    label: String(question[slot.key] ?? "").trim(),
  })).filter((slot) => slot.label);
}

function parseOptionPoints(raw, fallback = 1) {
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? Math.trunc(n) : fallback;
}

export function getImageQuizPointsForChoice(question, choiceKey, defaultPoints = 1) {
  const selected = String(question[choiceKey] ?? "").trim();
  const correct = String(question.correct_answer ?? "").trim();
  if (correct) {
    return normalizeAnswer(selected) === normalizeAnswer(correct) ? defaultPoints : 0;
  }

  const pointsKey = `${choiceKey}_points`;
  return parseOptionPoints(question?.[pointsKey], defaultPoints);
}

export function parseImageQuizFromTheme(themeData) {
  const themeDefault = Number(themeData?.points);
  const defaultPoints =
    Number.isFinite(themeDefault) && themeDefault > 0
      ? Math.trunc(themeDefault)
      : 1;

  const raw = ensureThemeJsonArray(themeData?.image_quiz);
  return raw
    .map((item) => {
      const imageFile = String(item?.image_file ?? "").trim();
      return {
        image_file: imageFile,
        image: imageFile ? getDvSourceImageUrl(imageFile) : "",
        option_one: String(item?.option_one ?? "").trim(),
        option_one_points: parseOptionPoints(item?.option_one_points, defaultPoints),
        option_two: String(item?.option_two ?? "").trim(),
        option_two_points: parseOptionPoints(item?.option_two_points, defaultPoints),
        option_three: String(item?.option_three ?? "").trim(),
        option_three_points: parseOptionPoints(item?.option_three_points, defaultPoints),
        option_four: String(item?.option_four ?? "").trim(),
        option_four_points: parseOptionPoints(item?.option_four_points, defaultPoints),
        correct_answer: String(item?.correct_answer ?? "").trim(),
        default_points: defaultPoints,
      };
    })
    .filter((q) => {
      const hasPrompt = Boolean(q.image);
      const optionCount = [q.option_one, q.option_two, q.option_three, q.option_four].filter(
        Boolean
      ).length;
      return hasPrompt && optionCount >= 4;
    });
}

export function normalizeAnswer(val) {
  return String(val ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export function isCorrectImageQuizChoice(question, choiceKey) {
  const selected = question[choiceKey];
  return normalizeAnswer(selected) === normalizeAnswer(question.correct_answer);
}
